import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import FeedbackComments from './FeedbackComments';
import ReportCustomQuestionType from '../../ReportBuilder/Components/Review/ReportCustomQuestionType';
import FeedbackBottomBar from './FeedbackBottomBar';
import { FeedbackCommentProps } from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';
import {
  CustomQuestion,
  CustomSingleQuestion,
  CustomQuestionAnswer,
} from 'admin/pages/ManageAccounts/CustomQuestions/utilts';
import { useFeedback } from '../FeedbackProvider';
import { updateCustomQuestionAnswer } from '../../ReportBuilder/Components/Review/ReportCustomQuestions';
import { requestInit } from 'shared/auth/hooks/useRequestState';
import FeedbackSupport from './FeedbackSupport';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { FeedbackDashboardCardProps } from 'shared/components/Feedback/FeedbackDashboardCard';
import FeedbackSectionButtons from './FeedbackSectionButtons';

interface FeedbackCustomQuestionProps {
  reportId: number;
  feedback: FeedbackDashboardCardProps;
  comments: FeedbackCommentProps[];
  customQuestion: {
    customQuestion: CustomQuestion;
    question: CustomSingleQuestion;
    questionIndex: number;
    customQuestionIndex: number;
    answer: CustomQuestionAnswer[];
    parsedQuestionId: number;
  };
  handleNext: () => void;
  handlePrevious: () => void;
  handleDoneQuestion: () => void;
  selectedIndex: number;
  isDone: boolean;
  isLastIndex: boolean;
  className?: string;
}

const StyledDiv = styled.div`
  .feedback-show-question {
    cursor: pointer;
    text-align: center;
    color: ${COLORS.ctaPrimary};
    margin-top: ${SPACERS.medium};
    margin-bottom: ${SPACERS.medium};
  }
`;

const FeedbackCustomQuestion: React.FC<FeedbackCustomQuestionProps> = ({
  reportId,
  comments,
  customQuestion,
  handleDoneQuestion,
  handlePrevious,
  handleNext,
  selectedIndex,
  isDone,
  isLastIndex,
  className,
}) => {
  const {
    setCustomQuestions,
    feedbackByQuestions,
    isVerificationStatus,
  } = useFeedback();

  // useEffect(() => {
  //   if (markAsResolvedRequestState.type === 'REQUEST_SUCCESS') {
  //     setMarkAsResolvedRequest(requestInit());
  //     handleNext();
  //   }
  // }, [markAsResolvedRequestState]);

  const handleChange = useCallback(
    (
      customQuestionIndex: number,
      questionIndex: number,
      questionId: number | string,
      answer: CustomQuestionAnswer,
    ) => {
      setCustomQuestions(
        updateCustomQuestionAnswer(
          customQuestionIndex,
          questionIndex,
          questionId,
          answer,
        ),
      );
      handleDoneQuestion();
    },
    [setCustomQuestions, handleDoneQuestion],
  );

  return (
    <StyledDiv className={className}>
      <FeedbackComments
        reportId={reportId}
        sectionId="custom_questions"
        questionId={customQuestion.parsedQuestionId}
        comments={comments}
        isCustomQuestion={true}
      />
      <ReportCustomQuestionType
        reportId={reportId}
        disableEdit={isVerificationStatus}
        key={customQuestion.parsedQuestionId}
        answer={customQuestion.answer}
        onChange={handleChange}
        customQuestionIndex={customQuestion.customQuestionIndex}
        customQuestion={customQuestion.customQuestion}
        questionIndex={customQuestion.questionIndex}
        question={customQuestion.question}
        handleAddDoneQuestionId={handleDoneQuestion}
        handleRemoveDoneQuestionId={() => null}
      />
      <FeedbackSectionButtons
        isCustomQuestion={true}
        selectedIndex={selectedIndex}
        hideEditButton={!isVerificationStatus}
        isVerificationStatus={isVerificationStatus}
        questionId={customQuestion.parsedQuestionId}
        question={feedbackByQuestions[selectedIndex]}
        handleNext={handleNext}
        openEditModal={() => null}
      />
      {!isVerificationStatus && (
        <FeedbackSupport
          reportId={reportId}
          label="I have a question"
          className="feedback-show-question"
          questionId={customQuestion.parsedQuestionId}
        />
      )}
      <FeedbackBottomBar
        handlePrevious={handlePrevious}
        handleNext={handleNext}
        selectedIndex={selectedIndex}
        isDone={isDone}
        isLastIndex={isLastIndex}
      />
    </StyledDiv>
  );
};

export default FeedbackCustomQuestion;
